<template>
  <v-container>
    <!--subheader-->
    <!-- status -->
    <!-- intro -->
    <p class="text-justify pb-2">
      Please use the following chart examples as guidelines.
    </p>
    <v-card>
      <v-card-text>
        <!-- good -->
        <h5 class="headline mb-1 text-left">Action Recommended</h5>
        <hr size="1" />
        <img src="@/assets/img/help/action.png" class="chart" />
        <p class="text-justify pt-3">
          Action is recommended because the value at stake on this day reaches a
          very high level. In this example the value at stake exceeds $400,000
          between 14:30 hours and 18:45 hours (red line).
        </p>
        <p class="text-justify">
          To recognize this value, the recommended level of total power output
          (blue line) ranges from 1,997 kW to 1,349 kW during that same time
          window. Total power output is the sum of all onsite generation.
          Sustaine's recommendation is based on our load forecast. Bottom line:
          Run the facility to maintain total power output from 1,997 to 1,349 kW
          between 14:30 and 18:45 and create substantial savings for the next
          year.
        </p>
        <p class="text-justify">
          Note: In most cases, the value recognized is in proportion to the
          power output. In other words, if power output is only 80% of that
          recommended, the value realized will be a similar proportion.
        </p>
        <p class="text-justify">
          However, the time span is usually NOT in proportion. For example, if
          power output from 14:30 to 17:30 is as recommended, but power output
          from 17:30 to 18:45 is half that recommended, the value recognized is
          likely to be halved, as well.
        </p>
        <p class="text-justify">
          A good rule of thumb: Running at the right time is critical. Running
          at the right level is also important.
        </p>
      </v-card-text>
    </v-card>

    <v-card class="mt-3">
      <v-card-text>
        <!-- good -->
        <h5 class="headline mb-1 text-left">Not Actionable</h5>
        <hr size="1" />
        <img src="@/assets/img/help/noaction.png" class="chart" />
        <p class="text-justify pt-3">
          No action is recommended because the value at stake on this day
          remains low throughout the day.
        </p>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  // == Name
  name: 'ValueAtStakeHelp'
}
</script>
<style lang="scss" scoped>
img.chart {
  width: 100%;
  max-width: 1100px;
}
</style>
